export function assert<T>(value: T): asserts value {
  if (!value) {
    throw new Error("value is not a truthy");
  }
}
